import React, { useState } from "react";

function Autofill({
  answerSets = {},
  journeyId,
  site,
  fillCustomJourneyAnswersPath,
  fillJourneyAnswersPath
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [customAnswerSet, setCustomAnswerSet] = useState("");
  const [selectedAnswerSet, setSelectedAnswerSet] = useState("");

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = (e) => {
    if (e.target === e.currentTarget) {
      setIsOpen(false);
      setIsWaiting(false);
    }
  };

  const submitForm = (e, endpoint, answerSetKey, answerSetValue) => {
    e.preventDefault();
    setIsWaiting(true);

    const formData = new FormData();
    formData.append('journey_id', journeyId);
    formData.append('site', site);
    formData.append(answerSetKey, answerSetValue);

    fetch(endpoint, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
      }
    })
      .then(response => {
        if (response.redirected) {
          window.location.href = response.url;
        }
      })
.catch(error => {
  console.error('Error:', error);
})
.finally(() => {
  setIsWaiting(false);
});
  };

  const handleCustomSubmit = (e) =>
    submitForm(e, fillCustomJourneyAnswersPath, 'custom_answer_set', customAnswerSet);

  const handlePresetSubmit = (e) =>
    submitForm(e, fillJourneyAnswersPath, 'answer_set', selectedAnswerSet);

  // Convert grouped answer sets to grouped options for select
  const renderAnswerSetOptions = () => {
    return Object.entries(answerSets).map(([groupLabel, options]) => (
      <optgroup key={groupLabel} label={groupLabel}>
        {options.map(([insurerName, value]) => (
          <option key={value} value={value}>
            {insurerName}
          </option>
        ))}
      </optgroup>
    ));
  };

  return (
    <div
      id="chopin-auto-fill"
      data-module="auto_fill"
      tabIndex="-1"
      className={`${isOpen ? 'opening open' : ''} ${isWaiting ? 'wait' : ''} on`}
      onClick={handleClose}
    >
      <button onClick={handleOpen}>Auto Fill</button>

      <div className="answer-sets">
        <ul>
          <li className="answer-sets__set-1">
            <form onSubmit={handleCustomSubmit} data-smart-form-disabled="true">
              <input type="hidden" name="journey_id" value={journeyId} />
              <input type="hidden" name="site" value={site} />
              <label htmlFor="custom_answer_set">Custom answer set</label>
              <textarea
                id="custom_answer_set"
                name="custom_answer_set"
                placeholder="Enter answer set in JSON format here"
                value={customAnswerSet}
                onChange={(e) => setCustomAnswerSet(e.target.value)}
              />
              <input
                type="submit"
                value="Submit Custom Answers"
                className="answer-set-button"
              />
            </form>
          </li>
          <li className="answer-sets__set-2">
            <form onSubmit={handlePresetSubmit} data-smart-form-disabled="true">
              <input type="hidden" name="journey_id" value={journeyId} />
              <input type="hidden" name="site" value={site} />
              <label htmlFor="answer_set">Answer set</label>
              <div className="select-wrapper">
                <select
                  id="answer_set"
                  name="answer_set"
                  value={selectedAnswerSet}
                  onChange={(e) => setSelectedAnswerSet(e.target.value)}
                >
                  <option value="">Please select</option>
                  {renderAnswerSetOptions()}
                </select>
              </div>
              <input
                type="submit"
                value="Submit Answer Set"
                className="answer-set-button"
              />
            </form>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Autofill;
